export * from './confirm-demo.component';
